/*
 * Originally from:
 * https://github.com/zhukov/webogram
 * Copyright (C) 2014 Igor Zhukov <igor.beatle@gmail.com>
 * https://github.com/zhukov/webogram/blob/master/LICENSE
 */

import App from '@config/app';
import {MOUNT_CLASS_TO} from '@config/debug';
import Modes from '@config/modes';
import loadScript from '@helpers/dom/loadScript';
import tsNow from '@helpers/tsNow';
import sessionStorage from '@lib/sessionStorage';

export class TelegramMeWebManager {
  private disabled = /* false &&  */(Modes.test || !App.domains.includes(location.hostname));

  public setAuthorized(canRedirect: boolean) {
    if(this.disabled) {
      return;
    }

    return sessionStorage.get('telesrv_sync').then((curValue) => {
      const ts = tsNow(true);
      if(
        canRedirect &&
        curValue?.canRedirect === canRedirect &&
        (curValue.ts + 86400) > ts
      ) {
        return;
      }

      sessionStorage.set({
        telesrv_sync: {
          canRedirect,
          ts
        }
      });

      const path = `_websync_?authed=${canRedirect ? '1' : '0'}&version=${encodeURIComponent(App.version + ' ' + App.suffix)}`;
      const urls = [
        '//cr0.ir/' + path,
        '//web.cr0.ir/' + path
      ];

      const promises = urls.map((url) => {
        return loadScript(url).then((script) => {
          script.remove();
        });
      });

      return Promise.all(promises);
    });
  }
}

const telegramMeWebManager = new TelegramMeWebManager();
MOUNT_CLASS_TO && (MOUNT_CLASS_TO.telegramMeWebManager = telegramMeWebManager);
export default telegramMeWebManager;
